/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './chartjs-chart.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/chartjs-chart/chartjs-chart.component';
const styles_ChartJSChartComponent:any[] = [i0.styles];
export const RenderType_ChartJSChartComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ChartJSChartComponent,data:{}});
export function View_ChartJSChartComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{canvasEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['canvas',
      1]],(null as any),0,'canvas',[['height','400'],['width','800']],(null as any),
      (null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_ChartJSChartComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-chartjs-chart',
      ([] as any[]),(null as any),(null as any),(null as any),View_ChartJSChartComponent_0,
      RenderType_ChartJSChartComponent)),i1.ɵdid(4898816,(null as any),0,i2.ChartJSChartComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ChartJSChartComponentNgFactory:i1.ComponentFactory<i2.ChartJSChartComponent> = i1.ɵccf('admin-chartjs-chart',
    i2.ChartJSChartComponent,View_ChartJSChartComponent_Host_0,{width:'width',height:'height',
        type:'type',labels:'labels',datasets:'datasets',sparkline:'sparkline',opaque:'opaque'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NoYXJ0anMtY2hhcnQvY2hhcnRqcy1jaGFydC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvY2hhcnRqcy1jaGFydC9jaGFydGpzLWNoYXJ0LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NoYXJ0anMtY2hhcnQvY2hhcnRqcy1jaGFydC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NoYXJ0anMtY2hhcnQvY2hhcnRqcy1jaGFydC5jb21wb25lbnQudHMuQ2hhcnRKU0NoYXJ0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGNhbnZhcyB3aWR0aD1cIjgwMFwiIGhlaWdodD1cIjQwMFwiICNjYW52YXM+PC9jYW52YXM+IiwiPGFkbWluLWNoYXJ0anMtY2hhcnQ+PC9hZG1pbi1jaGFydGpzLWNoYXJ0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztzRENBQTtNQUFBO01BQUE7OztvQkNBQTtNQUFBO3NDQUFBLFVBQUE7TUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/chartjs-chart/chartjs-chart.component.ngfactory.ts